(() => {
  if (customElements.get("announcement-bar-slider")) {
    return;
  }

  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const slidesCount =
        this.querySelectorAll(".swiper-slide").length;

      const hasMultipleSlides = slidesCount > 1;

      const tabletSlidesPerView = Math.min(
        3,
        slidesCount
      );

      this.swiper = new Swiper(this, {
        loop: false,
        rewind: hasMultipleSlides,
        speed: 500,

        /* =========================
           MOBILE
           ========================= */

        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,

        ...(hasMultipleSlides &&
          this.dataset.autoplay === "true" && {
            autoplay: {
              delay: Number(
                this.dataset.autoplayDelay
              ),
              disableOnInteraction: false
            }
          }),

        breakpoints: {

          /* =========================
             TABLET
             ========================= */

          768: {
            slidesPerView: tabletSlidesPerView,
            spaceBetween: 24,
            centeredSlides: false
          },

          /* =========================
             DESKTOP
             ========================= */

          1024: {
            slidesPerView: "auto",
            spaceBetween: 0,
            centeredSlides: false
          },

          /* =========================
             LARGE DESKTOP
             ========================= */

          1400: {
            slidesPerView: "auto",
            spaceBetween: 0,
            centeredSlides: false
          }
        }
      });

      /*
       * Shopify theme editor
       */
      if (
        typeof Shopify !== "undefined" &&
        Shopify.designMode
      ) {
        document.addEventListener(
          "shopify:block:select",
          (event) => {
            const slide =
              event.target.closest(
                ".announcement-bar__slide"
              );

            if (
              !slide ||
              !this.contains(slide)
            ) {
              return;
            }

            const slideIndex = Number(
              slide.dataset.swiperSlideIndex || 0
            );

            this.swiper.slideTo(slideIndex);
          }
        );
      }
    }
  }

  customElements.define(
    "announcement-bar-slider",
    AnnouncementBarSlider
  );
})();